/**
 * Persists the collection context when navigating from a collection grid to a product,
 * and updates PDP breadcrumbs when the product URL has no collection segment.
 */
(function () {
  const STORAGE_KEY = 'travelpro:breadcrumbCollection';

  /**
   * @returns {{ handle: string, title: string, url: string } | null}
   */
  function readStoredCollection() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed.handle !== 'string') return null;
      return parsed;
    } catch {
      return null;
    }
  }

  /**
   * @param {{ handle?: string, title?: string, url?: string }} data
   */
  function writeStoredCollection(data) {
    if (!data || !data.handle) return;
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          handle: data.handle,
          title: data.title || data.handle,
          url: data.url || `/collections/${data.handle}`,
        })
      );
    } catch {
      /* sessionStorage unavailable */
    }
  }

  /**
   * @param {HTMLElement} gridRoot
   */
  function bindCollectionGrid(gridRoot) {
    const context = {
      handle: gridRoot.dataset.breadcrumbCollectionHandle,
      title: gridRoot.dataset.breadcrumbCollectionTitle,
      url: gridRoot.dataset.breadcrumbCollectionUrl,
    };

    if (!context.handle) return;

    gridRoot.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const link = target.closest('a[href*="/products/"]');
        if (!link || !gridRoot.contains(link)) return;

        writeStoredCollection(context);
      },
      true
    );
  }

  function applyStoredCollectionToBreadcrumb() {
    const nav = document.querySelector('[data-breadcrumb-nav]');
    if (!nav) return;

    if (window.location.pathname.includes('/collections/')) return;

    const allowed = (nav.dataset.productCollectionHandles || '')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    const stored = readStoredCollection();
    if (!stored || !allowed.includes(stored.handle)) return;

    const serverHandle = nav.dataset.breadcrumbCollectionHandle || '';
    if (serverHandle === stored.handle) return;

    const link = nav.querySelector('[data-breadcrumb-collection-link]');
    if (!(link instanceof HTMLAnchorElement)) return;

    link.href = stored.url || `/collections/${stored.handle}`;
    link.textContent = stored.title || stored.handle;
    nav.dataset.breadcrumbCollectionHandle = stored.handle;
  }

  function init() {
    if (window.Theme?.template?.name === 'collection') {
      document.querySelectorAll('[data-breadcrumb-collection-handle]').forEach((el) => {
        if (el instanceof HTMLElement) bindCollectionGrid(el);
      });
    }

    if (window.Theme?.template?.name === 'product') {
      applyStoredCollectionToBreadcrumb();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
